import React from 'react';
import LetterBlock from 'components/UI/LetterBlock/LetterBlock';
import './SoundTypes.module.scss';
import MultiKeyboardBlocks from '../MultiKeyboardBlocks/MultiKeyboardBlocks';

export default function UncommonSounds() {
    return (
        <div styleName="grid-wrapper ">
            <div styleName="row">
                <LetterBlock letter="’s" soundType="special-character-sound" />
                <LetterBlock letter="ë" soundType="special-character-sound" />
                <LetterBlock letter="ï" soundType="special-character-sound" />
                <LetterBlock letter="ö" soundType="special-character-sound" />
                <LetterBlock letter="ü" soundType="special-character-sound" />
                <LetterBlock letter="ä" soundType="special-character-sound" />
            </div>
            <div styleName="row">
                <LetterBlock letter="g" soundType="special-character-sound" />
                <MultiKeyboardBlocks letters="ch">
                    <LetterBlock
                        letter="c"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="h"
                        soundType="special-character-sound"
                    />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="air">
                    <LetterBlock
                        letter="a"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="i"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="r"
                        soundType="special-character-sound"
                    />
                </MultiKeyboardBlocks>
            </div>
            <div styleName="row">
                <MultiKeyboardBlocks letters="aise">
                    <LetterBlock
                        letter="a"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="i"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="s"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="e"
                        soundType="special-character-sound"
                    />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="ou">
                    <LetterBlock
                        letter="o"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="u"
                        soundType="special-character-sound"
                    />
                </MultiKeyboardBlocks>
            </div>
            <div styleName="row">
                <MultiKeyboardBlocks letters="eau">
                    <LetterBlock
                        letter="e"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="a"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="u"
                        soundType="special-character-sound"
                    />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="th">
                    <LetterBlock
                        letter="t"
                        soundType="special-character-sound"
                    />
                    <LetterBlock
                        letter="h"
                        soundType="special-character-sound"
                    />
                </MultiKeyboardBlocks>
                <LetterBlock letter="y" soundType="special-character-sound" />
            </div>
        </div>
    );
}
